export default {
  equip: [
    {
      name: "Aboubakar Karim",
      title: "CEO",
      link: "Aboubakar.jpeg"
    },
    {
      name: "Olivier Konan",
      title: "Chargé de projet, agriculture de précision",
      link: "Olivier.jpeg"
    },
    {
      name: "Fabrice N’guettia",
      title: "Superviseur d’exploitations agricoles",
      link: "Fabrice.jpeg"
    },
    {
      name: "Bakary Coulibaly",
      title: "Consultant en agronomie",
      link: "Bakary.jpeg"
    }
  ],
  technologies: [
    {
      name: "Stéphane Aymard Dion",
      title: "ICT manager",
      link: "Aymard.jpeg"
    },
    {
      name: "Mohamed K Coulibali",
      title: "Consultant, développeur fullstack",
      link: "Konoufo.jpg"
    },
    {
      name: "Hassan Kane",
      title: "Consultant en stratégie et en robotique",
      link: "Hassan.jpg"
    }
  ],
  admins: [
    {
      name: "Amadou Toure",
      title: "Responsable des opérations",
      link: "Amadou.jpeg"
    },
    {
      name: "Marianne Coulibaly",
      title: "Responsable administrative et financière",
      link: "Marianne.jpeg"
    },
    {
      name: "Daniel Lamarche",
      title: "Consultant juridique et en développement des affaires",
      link: "Daniel.jpeg"
    },
    {
      name: "Serge Assande",
      title: "Consultant en finance",
      link: "Ochou.jpeg"
    }
  ],
  drone: [
    {
      name: "Aboubakar Karim",
      title: "Pilote",
      link: "Aboubakar.jpeg"
    },
    {
      name: "Aymard Dion",
      title: "Pilote",
      link: "Aymard.jpeg"
    },
    {
      name: "Fabrice N’guettia",
      title: "Pilote",
      link: "Fabrice.jpeg"
    },
    {
      name: "Olivier Konan",
      title: "Pilote",
      link: "Olivier.jpeg"
    }
  ]
};



// WEBPACK FOOTER //
// /opt/build/repo/src/json/about.json.js